import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 28,
  height: 38,
}

const SportsCourt = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 27.157 37.683'
  >
    <g fill={color} transform='translate(27.157) rotate(90)'>
      <path
        d='M0,71.507V98.664H9.029V97.544H1.119v-4.2H2.243a8.263,8.263,0,1,0,0-16.527H1.119v-4.2H18.282v6.756a5.73,5.73,0,0,0,0,11.406v6.756h-7.76v1.119H37.683V71.507ZM1.119,83.041H4.478V87.13H1.119Zm1.124-5.1h0a7.144,7.144,0,1,1,0,14.288H1.119V88.249H5.6V81.922H1.119V77.941Zm16.038,11.72a4.61,4.61,0,0,1,0-9.152ZM19.4,80.509a4.61,4.61,0,0,1,0,9.152Zm17.162,6.62H33.2V83.041h3.359Zm0-5.208H32.085v6.327h4.478V92.23H35.439a7.144,7.144,0,1,1,0-14.288h1.124Zm0-5.1H35.439a8.263,8.263,0,1,0,0,16.527h1.124v4.2H19.4V90.788a5.73,5.73,0,0,0,0-11.406V72.626H36.563Z'
        transform='translate(0 -71.507)'
      />
    </g>
  </svg>
)

export default SportsCourt
